/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="relaypoints-leaflet" >
    <div :class="openFilter ? 'relaypoints-filters active' : 'relaypoints-filters'">
      <small>Filtres</small>
      <ion-radio-group :value="relaypointFilter" @ionChange="setFilter($event)">
        <ion-item lines="none">
          <ion-label>Rezo Covoit</ion-label>
          <ion-radio slot="start" :value="'covoit'"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>Rezo Pouce</ion-label>
          <ion-radio slot="start" :value="'pouce'"></ion-radio>
        </ion-item>
      </ion-radio-group>
      <div class="relaypoints-filters-button" @click="openFilter = !openFilter">
        <span class="mdi mdi-24px text-white " :class="openFilter ? 'mdi-close' : 'mdi-filter-variant'"></span>
      </div>
    </div>
    <ion-spinner v-if="loading" class="loading-relaypoint" color="dark" name="crescent"></ion-spinner>
  <l-map
    v-if="showCard"
    :ref="'map'"
    style="height: 300px; border-top-right-radius: 15px; border-top-left-radius: 15px;"
    :center="center"
    :zoom="zoom"
    :maxZoom="maxZoom"
    :options="optionsCard"
    @update:bounds="boundsUpdated"
  >
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <!--<l-control-fullscreen position="bottomright"></l-control-fullscreen>-->
    <l-control-zoom position="bottomright"></l-control-zoom>
    <!--<v-locatecontrol :options="{position : 'bottomright', keepCurrentZoomLevel: true}"/>-->
    <div v-if="LMarker">
      <l-marker v-for="(marker, index) in  LMarker" :lat-lng="marker.latlng" :key="index" @click="openDetailPoint(marker)">
        <l-icon
          :iconSize="[40, 40]"
          :iconAnchor="[20, 40]"
          :icon-url="marker.object.relayPointType.icon.url" >
        </l-icon>
      </l-marker>
    </div>
  </l-map>

    <div v-if="selectedRelaypoint" class="mc-white-container mc-relaypoint-container">
      <img class="relay-banner" :src="'assets/relaypoints.png'" alt="">
      <ion-icon class="close" name="close" @click="selectedRelaypoint = null;"></ion-icon>
      <div class="icon-container"><img height="70px" width="70px" :src="selectedRelaypoint.relayPointType.icon.url"></div>

      <div class="relaypoint-description">
        <br>
      <div class="">
        <div style="margin-bottom: 0px"><b style="font-size: 18px">{{selectedRelaypoint.relayPointType.name}}</b></div>
        <div style="margin-bottom: 10px"> <b class="grey" style="font-size: 22px">{{selectedRelaypoint.name}}</b></div>
        <div style="font-size: 15px" class="grey">
          <b>
          <div>{{selectedRelaypoint.address.displayLabel[0]}}</div>
          <div>{{selectedRelaypoint.address.displayLabel[1]}}</div>
          </b>
        </div>
        <div class="grey" style="font-size: 14px">Lat : {{selectedRelaypoint.address.latitude}} | Lng : {{selectedRelaypoint.address.longitude}}</div>
      </div>
      <br>
      <div style="font-size: 14px">
        <div class="grey" v-html="selectedRelaypoint.description">

        </div>
        <br>
        <!--
        <div v-if="selectedRelaypoint.fullDescription">
          <b>Services supplémentaires</b>
          <div class="grey">
            {{ selectedRelaypoint.fullDescription }}
          </div>
        </div>
        -->
        <div class="d-flex">
          <div class="d-flex flex-col align-center info-block" v-if="selectedRelaypoint.places">
            <span class="mdi mdi-account-multiple mdi-24px"></span>
            <div class="text-center"><b>Places <br> disponibles</b></div>
            <div class="grey"> {{ selectedRelaypoint.places }}</div>
          </div>
          <div class="d-flex flex-col align-center info-block" v-if="selectedRelaypoint.placesDisabled">
            <span class="mdi mdi-wheelchair-accessibility mdi-24px"></span>
            <div class="text-center"><b>Places PMR <br>disponibles</b></div>
            <div class="grey"> {{ selectedRelaypoint.placesDisabled }}</div>
          </div>
          <div class="d-flex flex-col align-center info-block" v-if="!selectedRelaypoint.free">
            <span class="mdi mdi-currency-eur mdi-24px"></span>
            <div class="text-center"><b>Accès <br> payant</b></div>
            <div class="grey"> OUI</div>
          </div>

        </div>
        <br><br>
        <div v-if="select">
          <div class="grey">Sélectionner ce point relais comme :</div>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button expand="full" @click="selectOrigin(selectedRelaypoint)">Origine</ion-button>
              </ion-col>
              <ion-col>
                <ion-button expand="full" @click="selectDestination(selectedRelaypoint)">Destination</ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <br>
      </div>

      </div>
    </div>
  </div>


</template>

<style lang="scss">

.relaypoints-leaflet {
  position: relative;
  margin: -20px;
  width: calc(100% + 40px);
}

.mc-relaypoint-container {
  position: fixed;
  border: 1px lightgrey solid;
  bottom: 0px;
  right: 0px;
  left: 0px;
  min-height: 100px;
  z-index: 9999999;
  color: var(--ion-color-primary);
}

.close {
  position: absolute;
  right: 10px;
  top: 10px;
  color: grey;
  font-size: 30px;
  cursor: pointer;
}

.grey {
  color: #59595B;
}

.desc {
  margin-bottom: 16px;
  font-size: 14px;
}

.no-wrap {
  white-space: nowrap;
}

.ml-10 {
  margin-left: 10px;
}


.relay-banner {
  margin: -20px;
  width: calc(100% + 40px);
  max-width: none;
}

.icon-container {
  height: 80px;
  width: 80px;
  background: white;
  border-radius: 40px;
  position: absolute;
  margin-top: -15px;
  padding: 5px;
}

.relaypoint-description {
  margin-left: 80px;
}

.info-block {
  margin-right: 20px;
}

.relaypoints-filters {
  background: white;
  width: 60%;
  position: absolute;
  top: 30px;
  left: -60%;
  z-index: 99999;
  padding: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.relaypoints-filters.active {
  left: 0%;
}

.relaypoints-filters-button {
  background: grey;
  width: 44px;
  position: absolute;
  top: 30px;
  left: 100%;
  z-index: 99999;
  padding: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}

.text-white {
  color: white;
}

.loading-relaypoint {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 999;
}


</style>

<script>
import { LMap, LMarker, LTileLayer, LPolyline, LPopup, LIcon, LControlZoom } from "@vue-leaflet/vue-leaflet";
import {LatLngBounds} from "leaflet";
import {isPlatform} from "@ionic/core";
import { address } from "../../../Shared/Mixin/address.mixin";
// import Vue2LeafletLocatecontrol from 'vue2-leaflet-locatecontrol'
// import LControlFullscreen from 'vue2-leaflet-fullscreen';

export default {
  name: "relaypoints-map",
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      zoom: 5,
      maxZoom: 10,
      center: [47.2350952, 2.0426357],
      showCard: true,
      optionsCard: {
        dragging: !isPlatform(window.document.defaultView, "mobile"),
        touchZoom: isPlatform(window.document.defaultView, "mobile"),
        tap: !isPlatform(window.document.defaultView, "mobile"),
        zoomControl: false,
        fullscreenControl: false,
      },
      selectedRelaypoint: null,
      LMarker: [],
      openFilter: false,
      bounds: null,
      relayPointTypes : '',
      loading: false,
      relaypointFilter: null
    };
  },
  mixins: [address],
  components: {
    LMap,
    LControlZoom,
    LTileLayer,
    LPolyline,
    LMarker,
    LPopup,
    LIcon,
    // LControlFullscreen,
    // 'v-locatecontrol': Vue2LeafletLocatecontrol
  },
  props: ['filter', 'select'],
  created() {
    if(this.filter) {
      this.relaypointFilter = this.filter;
    }
  },
  mounted() {

    if (this.$store.state.userStore.user && this.$store.state.userStore.user.addresses && this.$store.state.userStore.user.addresses.length > 0) {
      const address = this.$store.state.userStore.user.addresses[0];
      this.center = [address.latitude, address.longitude];
      this.zoom = 10;
    }

    setTimeout(() => {
      if (!!this.$refs.map && !!this.$refs.map.leafletObject) {
        this.$refs.map.leafletObject.invalidateSize();
      }
    }, 100);

    setTimeout(() => {
      this.maxZoom = 18;
    }, 1000);

    this.setFilter(null);

    window.goToSearch = function (event) {
      let addressDTOOrigin = event.outwardWaypoints ? event.outwardWaypoints[0].address : event.origin;
      const displayGeoOrigin = this.formatAddress(event.outwardWaypoints ? event.outwardWaypoints[0].address : event.origin)
      let addressDTODestination = event.outwardWaypoints ? event.outwardWaypoints[event.outwardWaypoints.length -1].address : event.destination
      const displayGeoDestination = this.formatAddress(event.outwardWaypoints ? event.outwardWaypoints[event.outwardWaypoints.length -1].address : event.destination)
      this.$store.commit("changeOrigin", {
        addressDTO: addressDTOOrigin,
        displayGeo: displayGeoOrigin
      });
      this.$store.commit("changeDestination", {
        addressDTO: addressDTODestination,
        displayGeo: displayGeoDestination
      });

      /*
      this.$store.state.searchStore.searchObject.frequency = event.regular ? 2 : 1;
      this.$store.state.searchStore.searchObject.adId = event.proposalId;
       */
      let filters = null;
      if (this.communities && this.communities.length > 0) {
        filters = {communities: this.communities};
      }
      this.$router.push({ name: "search", params: {filters} });
    }.bind(this);

    window.selectOrigin = function (event) {
      console.log(event)
      const addressDTO = event.address;
      const displayGeo = this.formatAddress(event.address)
      this.$store.commit("changeOrigin", { addressDTO, displayGeo });
    }.bind(this);

    window.selectDestination = function (event) {
      console.log(event)
      const addressDTO = event.address;
      const displayGeo = this.formatAddress(event.address)
      this.$store.commit("changeDestination", { addressDTO, displayGeo });
    }.bind(this);
  },
  computed: {

  },
  methods: {
    maxiCard: function() {},
    setFilter(event) {
      console.log(event)
      if (event) {
        this.relaypointFilter = event.target.value;
        this.LMarker = [];
      }
      switch (this.relaypointFilter) {
        case 'covoit':
          this.relayPointTypes = '1,2,3,4,5,6,7,8,9,10,11,13,14,15';
          break;
        case 'pouce':
          this.relayPointTypes = '12';
          break;
      }
      this.getRelayPoint()
    },
    getRelayPoint() {
      this.loading = true;
      const data = {relayPointTypes: this.relayPointTypes, bounds: this.bounds, perPage: 1000}
      this.$store.dispatch('relay_points', data).then(res => {
        const result = [];
        res.forEach(element => {
          if (element.address.latitude && element.address.longitude) {
            result.push({
              latlng: [element.address.latitude, element.address.longitude],
              name: element.name,
              id: element.id,
              object: element
            });
          }
        });
        this.pushMarker(result)
        this.loading = false;

        /*
        if (!this.bounds) {
          this.setBounds();
        }
         */
      }).catch(err => {
        this.loading = false;
      })
    },
    openDetailPoint: function(marker) {
      this.selectedRelaypoint = marker.object;
    },
    boundsUpdated: function(bounds) {
      this.bounds = bounds._southWest.lng + ',' + bounds._northEast.lat + ',' + bounds._northEast.lng  + ',' + bounds._southWest.lat
      this.getRelayPoint();
    },
    setBounds() {
      let bounds;
      if (this.LMarker && this.LMarker.length > 0) bounds = new LatLngBounds(this.LMarker.map(item => item.latlng));
      if (this.LPolyline && this.LPolyline.length > 0) bounds = new LatLngBounds(this.LPolyline.map(item => item.latlng));
      if (!!this.$refs.map && !!this.$refs.map.leafletObject) {
        this.$refs.map.leafletObject.fitBounds(bounds);
        this.$refs.map.leafletObject.invalidateSize();
      }
      return bounds;
    },
    selectOrigin(event) {
      const addressDTO = event.address;
      const displayGeo = this.formatAddress(event.address)
      this.$store.commit("changeOrigin", { addressDTO, displayGeo });
      this.selectedRelaypoint = null
    },
    selectDestination(event) {
      console.log(event)
      const addressDTO = event.address;
      const displayGeo = this.formatAddress(event.address)
      this.$store.commit("changeDestination", { addressDTO, displayGeo });
      this.selectedRelaypoint = null
    },

    pushMarker(markers) {
      markers.forEach(marker => {
        const exist = this.LMarker.find(item => item.id === marker.id)
        if (!exist) {
          this.LMarker.push(marker);
        }
      })
    }
  }
};
</script>
